<script>
	import { onMount } from "svelte";
	import Claimant from "../../components/Claimant.svelte";
	import Contact from "../../components/Contact.svelte";
	import Form from "../../components/Form.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import Select from "../../components/Select.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
	import { projectSettings, referralTypes } from "../../config";
	import contactRelationshipToClaimant from "../../config/relationshipToClaimant";
	import registrationTypes from "../../config/registrationTypes";
	import { isUnderAge } from "../../helpers/dateHelpers";
	import model from "../../stores/modelStore";
	import { getTealiumID, registerPageComplete } from "../../tealium";
	import { isValid } from "../../validation";

	export let disabled = null;
	export let pageName = null;
	export let pageTitle = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let buttons = null;

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError);
				//displayError(response);
			} else {
				await registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);

				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		$model.tealiumId = getTealiumID();
	}

	const initialise = () => {};

	const handleDob = (event) => {
		$model.underAge = isUnderAge(event.detail.date);

		if ($model.underAge) {
			$model.registrationType = registrationTypes.types.Myself.value;
		}
	};

	initialise();

	onMount(() => {
		window.scrollTo(0, 0);
	});
</script>

<PageSection>
	<Form {disabled} id="form-personal-details" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Please provide your Contact Details</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<div class="confirmation-box-shadow">
			<Contact
				bind:firstName={$model.contact.firstName}
				bind:surname={$model.contact.surname}
				bind:emailAddress={$model.contact.emailAddress}
				bind:phoneNumber={$model.contact.phoneNumber}
				bind:address={$model.contact.address}
				bind:dateOfBirth={$model.contact.dateOfBirth}
				idPrefix="contact"
				isRegistrationUpdate={$model.isReturnReg}
				required
				{disabled}
				on:dateChange={handleDob}
				on:dateSelected={handleDob} />

			{#if !$model.underAge}
				<FormRow>
					<FormColumn>
						<Select
							required
							disabled={$model.isReturnReg ? true : disabled}
							label="Who are you registering for?"
							id="regType"
							bind:value={$model.registrationType}
							optionList={registrationTypes.options}
							textProperty="name"
							valueProperty="value" />
					</FormColumn>
				</FormRow>
			{/if}
		</div>

		{#if $model.underAge}
			<div style="margin-top: 2em;">
				<h2>Legal Guardian</h2>
				<FormRow class="confirmation-box-shadow">
					<FormColumn>
						<Select
							required
							disabled={$model.isReturnReg ? true : disabled}
							label="Relationship to you"
							id="relationshipToClaimant"
							bind:value={$model.relationshipToClaimant}
							optionList={contactRelationshipToClaimant.options}
							textProperty="name"
							valueProperty="value" />
					</FormColumn>
				</FormRow>
				<div class="confirmation-box-shadow">
					<Contact
						bind:firstName={$model.secondaryContact.firstName}
						bind:surname={$model.secondaryContact.surname}
						bind:emailAddress={$model.secondaryContact.emailAddress}
						bind:phoneNumber={$model.secondaryContact.phoneNumber}
						bind:address={$model.secondaryContact.address}
						bind:dateOfBirth={$model.secondaryContact.dateOfBirth}
						minimumAge={18}
						dateOfBirthValidationMessage="The legal guardian must be at least 18 years old."
						idPrefix="secondary"
						isRegistrationUpdate={$model.isReturnReg}
						required
						{disabled} />
				</div>
			</div>
		{:else if $model.registrationType && $model.registrationType != registrationTypes.types.Myself.value}
			<div class="confirmation-box-shadow">
				<div class="claimant-details">
					<Claimant
						disabled={$model.isReturnReg ? true : disabled}
						registrationType={$model.registrationType}
						bind:claimant={$model.claimant}
						bind:executors={$model.executors}
						bind:contactIsExecutor={$model.contactIsExecutor}
						bind:estateBeneficiary={$model.estateBeneficiary}
						bind:dependantOfDeceased={$model.dependantOfDeceased}
						bind:relationshipToClaimant={$model.contact.relationshipToClaimant}
						contactFirstName={$model.contact.firstName}
						contactSurname={$model.contact.surname} />
				</div>
			</div>
		{/if}

		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn>
					<Select
						required
						{disabled}
						label="Where did you hear about our firm?"
						id="whereDidYouHear"
						bind:value={$model.whereDidYouHear}
						optionList={referralTypes}
						textProperty="name"
						valueProperty="name" />
				</FormColumn>
			</FormRow>

			<FormRow>
				<FormColumn>
					<YesNoGroup
						required
						{disabled}
						label="Class actions can generate significant media interest. If media opportunities arise, are you willing to share your story with the press?"
						bind:value={$model.shareWithMedia}
						name="shareWithMedia" />
				</FormColumn>
			</FormRow>
		</div>

		<!-- <FormRow class="confirmation-hide">
			<FormColumn class="last">
				<SaveAndClose>Save and Close</SaveAndClose>
			</FormColumn>
		</FormRow> -->

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<NavigationButtons bind:buttons />
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>

<style>
	.claimant-details {
		margin-bottom: 20px;
	}
</style>
